<div class="idle-warning-container">
  <button mat-icon-button (click)="onStay()">
    <mat-icon> close </mat-icon>
  </button>

  <div class="contents">
    <p class="mat-headline-3 title">
      <strong>
        {{ 'sessionTimeout.title' | transloco }}
      </strong>
    </p>

    @if (isIdle) {
      {{
      'sessionTimeout.warn' | transloco : { countdown: countdown }
      }}
    } @else {
      {{ 'sessionTimeout.inquire' | transloco }}
    }

    <div mat-dialog-actions class="inactivity-dialog-options">
      <button mat-stroked-button color="primary" (click)="onLeave()">
        {{ 'sessionTimeout.signOut' | transloco }}
      </button>
      <button mat-flat-button color="primary" (click)="onStay()" cdkFocusInitial>
        {{ 'sessionTimeout.stay' | transloco }}
      </button>
    </div>
  </div>
</div>
